import { forwardRef, type ReactNode } from "react";
import { cx } from "@/shared/lib/cx";

export function AppShell({ collapsed, children }: { collapsed?: boolean; children: ReactNode }) {
  return (
    <div
      data-theme="accela-donutwork"
      className={cx("app-drawer min-h-screen bg-base-200", collapsed && "is-collapsed")}
    >
      {children}
    </div>
  );
}

export const Sidebar = forwardRef<HTMLElement, { children: ReactNode; className?: string }>(function Sidebar(
  { children, className },
  ref,
) {
  return (
    <aside
      ref={ref}
      className={cx("app-sidebar border-r border-base-300 bg-base-200", className)}
      aria-label="Primary navigation"
    >
      {children}
    </aside>
  );
});

export function Topbar({ children }: { children: ReactNode }) {
  return (
    <header className="app-navbar navbar min-h-0 border-b border-base-300 bg-base-100/95 px-3 shadow-none lg:px-6">
      {children}
    </header>
  );
}
